"use strict";

exports.__esModule = true;
exports.DeviceConnectivityWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _DeviceConnectivityElement = require("./DeviceConnectivityElement");
var _DeviceConnectivityFields = require("./DeviceConnectivityFields");
var _DeviceConnectivityThumbnail = require("./DeviceConnectivityThumbnail");
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DeviceConnectivityWidget = exports.DeviceConnectivityWidget = {
  name: "DeviceConnectivity",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "DeviceConnectivityWidget.label",
    defaultMessage: "Device Connectivity"
  }),
  icon: "property",
  group: _widgetGroups.DEVICE_INFORMATION_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "DeviceConnectivity",
      props: Object.assign({
        width: 450,
        height: 135,
        showAgentStatus: true,
        showAdapterStatus: true,
        showDataSourceStatus: true,
        entityRelativeWidth: 25,
        hostRelativeWidth: 25,
        portRelativeWidth: 25
      }, props),
      children: []
    };
  },
  showInPalette: true,
  isParent: false,
  requiresContexts: ["device"],
  suppliesContexts: [],
  optionalProps: ["fontFamily", "fontSize", "fontWeight", "fontStyle", "textDecoration", "textAlignment", "color"],
  requiresProps: ["x", "y", "width", "height", "showAgentStatus", "showAdapterStatus", "showDataSourceStatus", "entityRelativeWidth", "hostRelativeWidth", "portRelativeWidth"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 450,
      min: 32,
      max: 3840
    },
    height: {
      "default": 135,
      min: 32,
      max: 2160
    }
  },
  components: {
    Element: _DeviceConnectivityElement.DeviceConnectivityElement,
    Fields: _DeviceConnectivityFields.DeviceConnectivityFields,
    Thumbnail: _DeviceConnectivityThumbnail.DeviceConnectivityThumbnail
  }
};